import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function CharityDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  const mediaLinks = data.media?.linkLocalizations ?? [];

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Name"
        fieldKey="localizedName"
        data={data.localizedName}
        diffKeys={diffKeys}
        side={side}
      />
      <LocalizedField
        label="Description"
        fieldKey="localizedDescription"
        data={data.localizedDescription}
        diffKeys={diffKeys}
        side={side}
      />
      {/* Active field — hidden for now
      <FieldRow
        label="Active"
        value={data.isActive == null ? null : (data.isActive ? 'Yes' : 'No')}
        isChanged={diffKeys.has('isActive')}
        side={side}
      />
      */}

      <SectionBlock title="Links" />
      <FieldRow
        label="Website URL"
        value={data.websiteUrl}
        isChanged={diffKeys.has('websiteUrl')}
        side={side}
      />
      <FieldRow
        label="Donation URL"
        value={data.donationUrl}
        isChanged={diffKeys.has('donationUrl')}
        side={side}
      />

      {mediaLinks.length > 0 && (
        <>
          <SectionBlock title="Media" />
          {mediaLinks.map((entry) => (
            <FieldRow
              key={entry.localeId ?? 'media'}
              label={`Image (${(entry.localeId ?? '').slice(0, 2).toUpperCase() || '?'})`}
              value={entry.mediaLink ?? '—'}
              isChanged={diffKeys.has('media')}
              side={side}
            />
          ))}
        </>
      )}
    </Box>
  );
}
